import { Hero, News, Events } from '../../components';
import './Home.css';
import { useAuth } from '../../provider/auth';
import { list_news, list_events, get_user_info } from '../../api/functions';
import { useEffect, useState } from 'react';
import { useApi } from '../../api/api';
const Home = () => {
  const { token } = useAuth();
  const listNewsApi = useApi(list_news, 300);
  const listEventsApi = useApi(list_events, 300);
  const getUserInfoApi = useApi(get_user_info);


  useEffect(() => {
    const fetchData = async () => {
      const userInfo = await getUserInfoApi.execute();
      const showPrivate = await (userInfo?.is_member || false);
      listNewsApi.execute({ skip: 0, limit: 21, show_private: showPrivate });
      listEventsApi.execute({ skip: 0, limit: 21, show_private: showPrivate, time_filter: "upcoming" });
    };
    fetchData();
  }, [token]);

  return (
    <main className="home-main">
      <Hero />
      <News newsItems={listNewsApi.data || []} isLoading={listNewsApi.loading} />
      <Events eventsItems={listEventsApi.data || []} isLoading={listEventsApi.loading} />
    </main>
  );
};

export default Home;